export const FULLSTORY_EVENTS = {
  addToCart: 'Action | Add to cart clicked',
  newsletterSubscribed: 'Action | Subscribed to newsletter',
  comingSoonSubscribed: 'Action | Subscribed to coming soon',
  backInStockSubscribed: 'Action | Subscribed to notify me when back in stock',
  livechatClicked: 'Action | Livechat clicked',
  feedbackButtonClicked: 'Action | Feedback button clicked',
  exitIntentBannerViewed: 'View | Exit Intent Banner',
  sizeGuideOpened: 'View | Size guide opened',
  quickShopOpened: 'View | Quick shop opened',
  campaignVideoStarted: 'Campaign video started',
  campaignVideoEnded: 'Campaign video ended',
} as const;
